import { ReactElement } from "react"

export interface ILabelProps {
    children?: ReactElement
    isRequired?: boolean
    label: string | JSX.Element
    description?: string | JSX.Element
    hidden?: boolean
    extraClassNames?: string
}

export const Label = ({ children, isRequired, label, hidden, extraClassNames, description }: ILabelProps) => {
    return (
        <label className={`block ${hidden ? 'hidden' : ''} ${extraClassNames ? extraClassNames : ""}`}>
            <div className="flex flex-col py-2 mb-2 ">
                <p className={`font-semibold`}>{label}{isRequired ? " (required)" : ""}</p>
                {description && <p className="text-slate-700 text-xs md:text-sm font-normal mt-1">{description}</p>}
            </div>
            {children}
        </label>
    )
}